"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSocialFacebook = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconSocialFacebook = function IconSocialFacebook(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23 12.067C23 5.955 18.075 1 12 1S1 5.955 1 12.067c0 5.524 4.022 10.102 9.281 10.932v-7.733H7.488v-3.2h2.793V9.629c0-2.773 1.643-4.306 4.155-4.306 1.203 0 2.463.217 2.463.217v2.724H15.51c-1.367 0-1.793.853-1.793 1.728v2.075h3.05l-.487 3.2h-2.563V23C18.978 22.17 23 17.59 23 12.067z"
  }));
};
exports.IconSocialFacebook = IconSocialFacebook;